import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-[#0d6efd] via-[#5dade2] to-[#eaf4ff] pt-32 pb-20 px-4 md:px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="Award" size={20} color="#ffffff" />
            <span className="text-white text-sm font-medium">Certified Technology Partners</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Enterprise-Grade Technology
            <br />
            <span className="text-[#eaf4ff]">Partnerships & Integrations</span>
          </h1>
          
          <p className="text-white/90 text-base md:text-lg lg:text-xl max-w-3xl mx-auto mb-8">
            Delivering comprehensive digital solutions through strategic alliances with industry-leading technology providers. Our certified partnerships ensure seamless integration, enterprise-grade security, and 24/7 support capabilities.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8 mt-12">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 md:p-6 lg:p-8 min-w-[140px] md:min-w-[180px] lg:min-w-[200px]">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2">15+</div>
              <div className="text-white/80 text-xs md:text-sm lg:text-base">Technology Partners</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 md:p-6 lg:p-8 min-w-[140px] md:min-w-[180px] lg:min-w-[200px]">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2">50+</div>
              <div className="text-white/80 text-xs md:text-sm lg:text-base">Certified Integrations</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 md:p-6 lg:p-8 min-w-[140px] md:min-w-[180px] lg:min-w-[200px]">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2">100%</div>
              <div className="text-white/80 text-xs md:text-sm lg:text-base">Enterprise Compliance</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;